import React, { useContext, useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import "../mergeorder.css";
import CloseIcon from "@mui/icons-material/Close";
import { Button } from "@mui/material";
import { StoreContext } from "../../../../store/Provider";
import "../../notification/index.css";
import instance from "../../../common/api/interceptor";
import { path } from "../../../constants/apiPath";
import { CircularProgress } from "@material-ui/core";
import { NotificationManager } from "react-notifications";
import { useNavigate, useLocation } from "react-router-dom";
import routeConstant from "../../../../route/compoent/routeConstant";
import { StoreContext as OrderContext } from "../../../store/index";
import { OrderContext as OrderListContext } from "../../orderList/store/index";

function ViewSubOrder() {
  const [mergedOrder, setMergedOrder] = useState([]);
  const [loading, setLoading] = useState(true);
  const context = useContext(StoreContext);
  const orderContext = useContext(OrderContext);
  const {
    setApprovedData,
    setShippedData,
    setRejectedData,
    setArchiveData,
    setPlacedData,
    setBuyerSelected,
  } = useContext(OrderListContext);
  const { setDashboardData } = useContext(OrderContext);
  const location = useLocation();
  const [deteachFlag, setDeteachFlag] = useState(false);

  const navigate = useNavigate();
  useEffect(() => {
    getAttachedOrder();
  }, []);

  const getAttachedOrder = () => {
    const body = {
      SearchData: "",
      OrgCodes: "",
      Status: "",
      SortColumnName: "",
      SortDirection: "",
      CurrentPage: 0,
      PageSize: 20,
    };
    instance
      .post(
        path.GET_ATTACHED_ORDER +
          `?orderPk=${context.notificationOpen.orderPk}&role=${context?.omsUserData?.UserRoles}`, //${context?.omsUserData?.UserRoles}`,
        { body }
      )
      .then((res) => {
        if (res.Is_Success) {
          setLoading(false);
          setMergedOrder([...res.data]);
        }
      })
      .catch((err) => {
        setLoading(false);

        console.log(err);
      });
  };
  console.log(mergedOrder);
  const detachOrder = (item) => {
    console.log(item);
    const body = {
      Pk: context.notificationOpen.orderPk,
      FKs: [{ FK: item }],
    };
    instance
      .post(path.DETACH_ORDER, body)
      .then((res) => {
        console.log(res);
        if (res.Is_Success) {
          // refereshData();
          setDeteachFlag(true);
          const index = mergedOrder.findIndex((e) => e.OrderPK === item);
          const arr = [...mergedOrder];
          arr.splice(index, 1);
          setMergedOrder([...arr]);
          NotificationManager.success(res.Message, "", 3000);
        } else {
          NotificationManager.error(res.Message, "", 3000);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const refereshData = () => {
    const path = location.pathname.split("/").pop();
    switch (path) {
      case "placed":
        setPlacedData({
          data: [],
          page: 0,
          hasMore: false,
        });
        setBuyerSelected("");
        break;
      case "approved":
        setApprovedData({
          data: [],
          page: 0,
          hasMore: false,
        });
        break;
      case "loaded":
        setShippedData({
          data: [],
          page: 0,
          hasMore: false,
        });

        break;

      case "cancelled":
        setRejectedData({
          data: [],
          page: 0,
          hasMore: false,
        });
        break;

      case "archived":
        setArchiveData({
          data: [],
          page: 0,
          hasMore: false,
        });

        break;
      case "dashboard":
        setDashboardData({});
        break;
      default:
        break;
    }
  };

  const onActionChange = (e, orderPk) => {
    if (e.target.value === "Detach") {
      detachOrder(orderPk);
    } else if (e.target.value === "FullDetails") {
      // details
      onCardHandler(orderPk);
    } else {
      // edit
      onEdit(orderPk);
    }
  };

  const onCardHandler = (orderPk) => {
    // alert(orderPk)
    orderContext.setBackDropOpen(true);

    instance
      .get(`${path.GET_ORDER_DETAIL}?orderPk=${orderPk}`)
      .then((res) => {
        orderContext.setBackDropOpen(false);

        if (res.Is_Success) {
          context.setNotificationOpen({
            open: false,
            type: "",
            reload: false,
          });
          navigate(routeConstant.DASH_ORDER_LIST_FULL, {
            state: res.data,
          });
        }
      })
      .catch((err) => {
        orderContext.setBackDropOpen(false);

        console.log(err);
      });
  };

  const onEdit = (orderPK) => {
    orderContext.setBackDropOpen(true);
    instance
      .get(`api/v1/Order/editOrder?orderPk=${orderPK}`)
      .then((res) => {
        if (res.Is_Success) {
          context.setNotificationOpen({
            open: false,
            type: "",
            reload: false,
          });

          orderContext.setEditOrderJSON(res.data ?? {});
          orderContext.setEditMode(true);
          navigate(routeConstant.LIST_EDIT_CREATE_ORDER, {
            state: { edit: true, editOrderJSON: res.data },
          });
        } else {
          NotificationManager.error(res.Message, "", 3000);
        }
        orderContext.setBackDropOpen(false);
      })
      .catch((err) => {
        console.error(err);
        if (err.response) {
          NotificationManager.error(err.response.data.Message, "", 3000);
        } else if (err.request) {
        } else if (err.message) {
        } else {
          NotificationManager.error("Something went wrong!", "", 3000);
        }
        orderContext.setBackDropOpen(false);
      });
  };

  return (
    <>
      <div className="_notificationSettingHeader">
        <h5 className="_suborderHeading">Sub Orders</h5>
        <Button
          title={"Close"}
          onClick={() => {
            if (deteachFlag) {
              refereshData();
            }
            setTimeout(() => {
              context.setNotificationOpen({
                open: false,
                type: "",
                reload: false,
              });
            }, 300);
          }}
        >
          <CloseIcon />
        </Button>
      </div>
      <div className="_suborderTable">
        {loading ? (
          <div className="bottomLoader">
            <CircularProgress size="1.5rem" />
          </div>
        ) : (
          <TableContainer component={Paper}>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="left">Order No.</TableCell>
                  <TableCell align="center">Buyier Code</TableCell>
                  <TableCell align="center">Supplier Code</TableCell>
                  <TableCell align="center">Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {mergedOrder.map((item, index) => {
                  const orderNumber =
                    item.SplitNumber == "0"
                      ? `${item.OrderNumber}`
                      : `${item.OrderNumber}/${item.SplitNumber}`;
                  return (
                    <TableRow
                      key={index}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell key={orderNumber} align="left">
                        {orderNumber}
                      </TableCell>
                      <TableCell key={item.OrderBuyerCode} align="center">
                        {item.OrderBuyerCode}
                      </TableCell>
                      <TableCell align="center">
                        {item.OrderSupplierCode}
                      </TableCell>
                      <TableCell key={item.OrderSupplierCode} align="center">
                        <select
                          className="_selectboxCards"
                          name="cars"
                          id="cars"
                          value=""
                          onChange={(e) => onActionChange(e, item.OrderPK)}
                        >
                          <option disabled selected value="">
                            Action
                          </option>
                          <option value="Edit">Edit</option>
                          {context.omsUserData?.UserRoles.includes("Admin") ? (
                            <option value="Detach">Detach</option>
                          ) : null}
                          <option value="FullDetails">Full Details</option>
                        </select>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </div>
    </>
  );
}

export default ViewSubOrder;
